import React from "react";

import { Phone, MessageSquare } from "lucide-react";

import "./Contact.css";

const Contact = () => {
  // SỐ ĐIỆN THOẠI NHẬN CUỘC GỌI VÀ SMS
  const phoneNumber = "0941342598";

  // NỘI DUNG SMS SOẠN SẴN
  const smsMessage =
    "Xin chào, tôi muốn rút tiền thẻ tín dụng. Báo phí ưu đãi qua zalo: ";

  // TẠO ĐƯỜNG DẪN SMS
  const smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(smsMessage)}`;

  return (
    <div className="floating-contact">
      {/* NÚT GỌI NGAY */}

      <a
        href={`tel:${phoneNumber}`}
        className="floating-btn floating-call"
        aria-label="Gọi ngay"
      >
        <Phone size={17} fill="white" />

        <span>Gọi ngay</span>
      </a>

      {/* NÚT NHẮN SMS */}

      <a
        href={smsLink}
        className="floating-btn floating-sms"
        aria-label="Nhắn tin SMS"
      >
        <MessageSquare size={17} fill="white" />

        <span>Nhắn SMS</span>
      </a>
    </div>
  );
};

export default Contact;
